module.exports = __webpack_public_path__ + "static/media/about__collage.6bfd815d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/about/about__collage.jpg
// module id = 200
// module chunks = 0